import styled from 'styled-components'


export const HeroDiv = styled.div `
	display: flex;
	justify-content: center;
    color: #fff;
	min-height: 100vh;
    background-repeat: no-repeat;
    background-attachment: scroll;
    background-position: center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
	padding:0;
	margin:0;

	

.banner {
	width: 100%;
}
.yourhealthbox{
	padding-top:120px;
	
}
h2{
	color: #1E90FF;
}
p{
	color: #24292E;
}




/* mobile view */
/* @media (max-width:500px){	
.banner{
	button{

		display:flex;
		align-items:center;
		justify-content:center;
		justify-self:center;
		}
	}

} */


@media (max-width:400px){
	.yourhealthbox{
		h2{
			font-family: Gilroy;
			/* font-style: normal; */
			font-weight: bold;
			/* font-size: 52px; */
			/* line-height: 98px; */
			font-feature-settings: 'liga' off;
			padding:0;
			line-height:20px;
		}
		
	}
}




`